import { useState } from "react";
import { faqItems } from "../data/landingData";
import Icon from "./Icons";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="section faq">
      <h2 className="section-title">Questions fréquentes</h2>
      <div className="faq-list">
        {faqItems.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className={`faq-item ${isOpen ? "open" : ""}`}>
              <button
                type="button"
                className="faq-question"
                onClick={() => setOpenIndex(isOpen ? -1 : i)}
                aria-expanded={isOpen}
              >
                <span>{item.question}</span>
                <Icon name={isOpen ? "chevron" : "plus"} className="faq-icon" />
              </button>
              {isOpen && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
